import { Component, OnInit, Input } from '@angular/core';
import { IEpGridModel } from '@epicor/kinetic';
import { IEpBtFaDocumentCardModel } from './epbt-fa-document-grid-card.model';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-document-grid-card',
  templateUrl: './epbt-fa-document-grid-card.component.html',
  styleUrls: ['./epbt-fa-document-grid-card.component.scss']
})
export class EpbtFaDocumentGridCardComponent implements OnInit {
  @Input()
  gridModel: IEpGridModel;
  @Input()
  cardField: Array<IEpBtFaDocumentCardModel>;

  @Input()
  cardType: string;

  @Input()
  bodyTemplate: any;

  @Input()
  headerTemplate: any;


  constructor() { }
  // constructor( ) { }
  ngOnInit() {
  }

  getList(model) {
    const data = [];
    if (model) {
      const list =  Object.keys(model);
      if (this.cardField) {
        this.cardField.filter(i => {
          list.filter(k => {
            if (k == i.field) {
              data.push({key : i.displayName, value : model[i.field], icon : i.icon});
            }
          });
        });
      }
    }
    return data;
  }

}
